import { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../services/firebase";
import HomeNavbar from "../components/HomeNavbar";
import HomeFooter from "../components/HomeFooter";
import "../components/HomeHF.css";
import "./Contact.css";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading]   = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError]       = useState(null);

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      setError("Please fill in all required fields.");
      return;
    }
    setLoading(true);
    setError(null);
    try {
      await addDoc(collection(db, "contacts"), {
        name:      form.name,
        email:     form.email,
        subject:   form.subject || "No subject",
        message:   form.message,
        createdAt: serverTimestamp(),
        status:    "unread",
      });
      setSubmitted(true);
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      console.error("Contact form error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <HomeNavbar />

      <div className="contact-page">
        <div className="contact-container">

          {/* Left side */}
          <div className="contact-info">
            <div className="contact-badge">Get in touch</div>
            <h1 className="contact-title">We'd love to hear from you</h1>
            <p className="contact-desc">
              Have a question, feedback, or just want to say hello? 
              Fill out the form and we'll get back to you within 24 hours.
            </p>

            <div className="contact-details">
              {/* <div className="contact-detail-item">
                <span className="contact-detail-icon">📧</span>
                <div>
                  <div className="contact-detail-label">Email</div>
                  <div className="contact-detail-value">creatorcommentweb@gmail.com</div>
                </div>
              </div> */}
              <div className="contact-detail-item">
                <span className="contact-detail-icon">⏱️</span>
                <div>
                  <div className="contact-detail-label">Response time</div>
                  <div className="contact-detail-value">Within 24 hours</div>
                </div>
              </div>
              <div className="contact-detail-item">
                <span className="contact-detail-icon">🌍</span>
                <div>
                  <div className="contact-detail-label">Support</div>
                  <div className="contact-detail-value">Available worldwide</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right side — Form */}
          <div className="contact-form-wrap">
            {submitted ? (
              <div className="contact-success">
                <div className="success-icon">✅</div>
                <h2>Message sent!</h2>
                <p>Thanks for reaching out. We'll get back to you within 24 hours.</p>
                <button
                  className="btn btn-primary"
                  onClick={() => setSubmitted(false)}
                  style={{ marginTop: 16 }}
                >
                  Send another message
                </button>
              </div>
            ) : (
              <div className="contact-form-card">
                <h2 className="form-title">Send us a message</h2>

                {error && (
                  <div className="contact-error">⚠️ {error}</div>
                )}

                <div className="form-group">
                  <label>Name <span className="required">*</span></label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Your name"
                    value={form.name}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label>Email <span className="required">*</span></label>
                  <input
                    type="email"
                    name="email"
                    placeholder="your@email.com"
                    value={form.email}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label>Subject</label>
                  <input
                    type="text"
                    name="subject"
                    placeholder="What's this about?"
                    value={form.subject}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label>Message <span className="required">*</span></label>
                  <textarea
                    name="message"
                    placeholder="Tell us how we can help..."
                    value={form.message}
                    onChange={handleChange}
                    rows={5}
                  />
                </div>

                <button
                  className="btn btn-primary contact-submit-btn"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  {loading ? <><span className="spinner" /> Sending...</> : "Send Message →"}
                </button>
              </div>
            )}
          </div>

        </div>
      </div>

      <HomeFooter />
    </div>
  );
}